import React, { Fragment, useState, useRef } from 'react';
import { AsyncTypeahead, Menu } from 'react-bootstrap-typeahead';

const MobileSearch = (props) => {
  const { id } = props;
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);

  const submitOnEnter = (evt) => {
    if (parseInt(evt.keyCode, 10) !== 13) {
      return;
    }
    const search = evt.target.value;
    if (search === '') {
      return;
    }
    const uri = encodeURI(`/search?q=${search}`);
    window.location.href = uri;
  };

  const ref = useRef(null);

  return (
    <>
      <AsyncTypeahead
        ref={ref}
        id={id}
        autoFocus={false}
        filterBy={() => true}
        placeholder="Поиск в магазине"
        isLoading={loading}
        minLength={3}
        labelKey="value"
        options={options}
        searchText={'Поиск...'}
        style={{ width: '100%' }}
        onSearch={(query) => {
          setLoading(true);
          fetch(`/search?json=1&q=${query}`)
            .then((resp) => resp.json())
            .then((data) => {
              if (data.length === 0) {
                setOptions([{ id: 0, type: 'empty', label: '' }]);
                return;
              }
              const newOptions = data.map((option, idx) => {
                option.id = idx;
                return option;
              });
              setOptions(newOptions);
            })
            .then(() => setLoading(false));
        }}
        onKeyDown={submitOnEnter}
        renderInput={({ inputRef, referenceElementRef, ...inputProps }) => {
          return (
            <label>
              <button className="block-inp__search">
                <img src="/static/img/icons/Search2.svg" alt="search" />
              </button>
              <input
                {...inputProps}
                type="text"
                ref={(input) => {
                  inputRef(input);
                  referenceElementRef(input);
                }}
              />
            </label>
          );
        }}
        renderMenu={(results, menuProps) => (
          <Menu {...menuProps} className="app-search__tt_menu">
            {results.map((option) => (
              <div className="app-search__item" key={option.id}>
                {option.type === 'empty' && (
                  <span>Товаров по вашему запросу не найдено</span>
                )}
                {option.type === 'product' && (
                  <>
                    <div className="app-search__title">
                      <a
                        href={option.url}
                        dangerouslySetInnerHTML={{
                          __html: option.value,
                        }}
                      />
                    </div>
                    <div className="app-search__category">
                      <a
                        href={option.catalogUrl}
                      >{` ${option.catalogName} `}</a>
                    </div>
                  </>
                )}
                {option.type === 'catalog' && (
                  <div className="app-search__title">
                    <a href={option.url}>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: option.value,
                        }}
                      />
                      &nbsp;
                      <span>раздел каталога</span>
                    </a>
                  </div>
                )}
              </div>
            ))}
          </Menu>
        )}
      />
    </>
  );
};

export default MobileSearch;
